import { useEffect, useState } from 'react';

import Image, { StaticImageData } from 'next/image';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

import IconClose from '@/assets/icons/icon-close-small.svg';
import { cn } from '@/utils/helper';

type TLoggedOutModalProps =
  | {
      image: StaticImageData;
      mobileImage?: StaticImageData;
      hideTitle?: boolean;
      showBackground?: boolean;
      closeAction?: () => void;
      text: string;
      canClose?: false;
      className?: string;
    }
  | {
      text: string;
      hideTitle?: boolean;
      showBackground?: boolean;
      canClose: true;
      closeAction?: () => void;
      className?: string;
    };

function LoggedOutModal({ text, hideTitle = false, showBackground = false, closeAction, className, ...props }: TLoggedOutModalProps) {
  const [open, setOpen] = useState(true);
  const pathname = usePathname();

  const canClose = 'canClose' in props;
  const image = 'image' in props && props.image;
  const mobileImage = 'mobileImage' in props && props.mobileImage;

  useEffect(() => {
    if (canClose && open) {
      if (open) {
        document.body.classList.add('overflow-hidden');
      } else {
        document.body.classList.remove('overflow-hidden');
      }
    }

    return () => {
      document.body.classList.remove('overflow-hidden');
    };
  }, [open, canClose]);

  return (
    open && (
      <div className={cn(canClose ? 'absolute top-0 size-full backdrop-blur-[15px] z-10 max-h-[calc(100vh-80px)]' : 'relative ', 'flex-grow  max-lg:h-[calc(100vh-81px)] ', showBackground ? 'bg-transparent' : 'dark:!bg-jet-black', className)}>
        {pathname.includes('/portfolio') && !canClose && image && <Image alt='loans image' src={image.src} layout='fill' className={cn('z-10 object-cover object-top', mobileImage && 'sm:block hidden')} quality={100} />}
        {pathname.includes('/portfolio') && !canClose && mobileImage && <Image alt='loans image' src={mobileImage.src} layout='fill' className='z-10 object-cover object-center block sm:hidden' quality={100} />}
        <div className='relative h-full'>
          <div className='max-w-[687px] w-[calc(100%-40px)] px-[29px] border rounded bg-white-100 dark:bg-jet-black-100 border-coal-50 dark:border-coal-border z-20 absolute inset-0 m-auto h-min flex-col py-10 lg:py-16 flex items-center justify-center'>
            {canClose && (
              <button
                onClick={() => {
                  setOpen(false);
                  if (closeAction) closeAction();
                }}
                className='absolute right-4 top-4'
              >
                <IconClose />
              </button>
            )}
            {!hideTitle && <p className='font-bold text-3xl lg:text-5xl mb-2 whitespace-nowrap'>Join NettyWorth</p>}
            <p className='text-[19px]/[24pxyy] font-normal text-center lg:text-2xl'>{text}</p>
            <div className='flex gap-[14px] mt-[18px]'>
              <Link href='/login' className='py-3 px-6 text-sm font-medium rounded bg-primary text-white'>
                Sign Up
              </Link>
              <Link href='/login' className='py-3 px-6 text-sm font-medium rounded border-coal-50 dark:border-coal-border border dark:text-white'>
                Login
              </Link>
            </div>
          </div>
        </div>
      </div>
    )
  );
}

export default LoggedOutModal;
